import { render } from "./PropertyValue.vue?vue&type=template&id=35075bfe&scoped=true&ts=true"
import script from "./PropertyValue.vue?vue&type=script&lang=ts"
export * from "./PropertyValue.vue?vue&type=script&lang=ts"

import "./PropertyValue.vue?vue&type=style&index=0&id=35075bfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35075bfe"]])

export default __exports__